(() => {
  "use strict";

  function initComparisonSliders(root = document) {
    // Strictly scope to this section to avoid collisions
    const sections = root.querySelectorAll(".comparison-table");
    sections.forEach((section) => {
      const sliders = section.querySelectorAll(".comparison-card__slider");
      sliders.forEach((slider) => {
        if (slider.dataset.initialized) return;

        const media = slider.closest(".comparison-card__media");
        if (!media) return;

        const beforeImg = media.querySelector(
          ".comparison-card__image--before"
        );
        const sliderLine = media.querySelector(".comparison-card__slider-line");
        const sliderButton = media.querySelector(
          ".comparison-card__slider-button"
        );

        function update(value) {
          const pct = `${value}%`;
          media.style.setProperty("--position", pct);

          // Safari fallback: directly update widths/positions
          if (beforeImg) beforeImg.style.width = pct;
          if (sliderLine) sliderLine.style.left = pct;
          if (sliderButton) sliderButton.style.left = pct;
        }

        slider.addEventListener("input", (e) => update(e.target.value));
        slider.addEventListener("change", (e) => update(e.target.value));

        update(slider.value || 50);
        slider.dataset.initialized = "true";
      });
    });
  }

  function initMobilePagination(root = document) {
    const sections = root.querySelectorAll(".comparison-table");

    sections.forEach((section) => {
      if (section.dataset.paginationInitialized) return;

      const sliderContainer = section.querySelector(".comparison-table__mobile-slider");
      const slides = section.querySelectorAll(".mobile-slide");
      const counterSpans = section.querySelectorAll(".comparison-table__counter span");
      const leftArrow = section.querySelector(".comparison-table__arrow--left");
      const rightArrow = section.querySelector(".comparison-table__arrow--right");

      if (!sliderContainer || slides.length === 0) return;

      let currentIndex = 0;
      const totalSlides = slides.length;

      function updateSlider() {
        // Move slider
        sliderContainer.style.transform = `translateX(-${currentIndex * 100}%)`;

        // Update counter
        counterSpans.forEach((span, idx) => {
          span.classList.toggle('active', idx === currentIndex);
        });

        // Disable arrows at ends
        if (leftArrow) {
          leftArrow.classList.toggle('disabled', currentIndex === 0);
        }
        if (rightArrow) {
          rightArrow.classList.toggle('disabled', currentIndex === totalSlides - 1);
        }

        // Reinitialize sliders for the current slide
        const currentSlide = slides[currentIndex];
        if (currentSlide) {
          const slider = currentSlide.querySelector('.comparison-card__slider');
          if (slider && !slider.dataset.initialized) {
            initComparisonSliders(currentSlide);
          }
        }
      }

      // Right arrow click
      if (rightArrow) {
        rightArrow.addEventListener('click', () => {
          if (currentIndex < totalSlides - 1) {
            currentIndex++;
            updateSlider();
          }
        });
      }

      // Left arrow click
      if (leftArrow) {
        leftArrow.addEventListener('click', () => {
          if (currentIndex > 0) {
            currentIndex--;
            updateSlider();
          }
        });
      }

      // Counter number clicks
      counterSpans.forEach((span, idx) => {
        span.addEventListener('click', () => {
          currentIndex = idx;
          updateSlider();
        });
      });

      updateSlider();
      section.dataset.paginationInitialized = "true";
    });
  }

  function onSectionLoad(evt) {
    const section = evt.target || evt.detail?.section;
    if (!section) return;
    initComparisonSliders(section);
    initMobilePagination(section);
  }

  // Initialize immediately if DOM is already ready, otherwise on DOMContentLoaded
  if (document.readyState !== "loading") {
    initComparisonSliders(document);
    initMobilePagination(document);
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      initComparisonSliders(document);
      initMobilePagination(document);
    });
  }

  // Support Theme Editor lifecycle
  document.addEventListener("shopify:section:load", onSectionLoad);
  document.addEventListener("shopify:section:select", onSectionLoad);
})();
